import React, { useState } from "react";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { toast } from "sonner";
import { araciMerkez } from "@/lib/api";

export default function AraciLeadActions({ lead, compact = false, onDone }) {
    const [busy, setBusy] = useState(false);
    const [showRed, setShowRed] = useState(false);
    const [sebep, setSebep] = useState("");
    const [dosyaOlustur, setDosyaOlustur] = useState(false);
    const [hakedisTutar, setHakedisTutar] = useState("");

    if (!lead || !["BEKLEMEDE", "INCELENDI"].includes(lead.durum)) {
        return null;
    }

    async function handleOnayla() {
        setBusy(true);
        try {
            const onizle = await araciMerkez.leadOnizle(lead.id);
            if (onizle.cift_kayit_riski && !onizle.muvekkil_eslesmeler?.length) {
                toast.warning("Telefon eşleşmesi var — mevcut müvekkil kullanılacak.");
            }
            const payload = {
                dosya_olustur: dosyaOlustur,
            };
            if (hakedisTutar.trim()) {
                payload.hakedis_tutar = hakedisTutar.trim();
            }
            const res = await araciMerkez.leadOnayla(lead.id, payload);
            toast.success(
                `Onaylandı · Müvekkil #${res.muvekkil_id}${res.dosya_no ? ` · ${res.dosya_no}` : ""}`,
            );
            onDone?.();
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Onay başarısız.");
        } finally {
            setBusy(false);
        }
    }

    async function handleReddet() {
        if (!sebep.trim()) {
            toast.error("Red sebebi girin.");
            return;
        }
        setBusy(true);
        try {
            await araciMerkez.leadReddet(lead.id, sebep.trim());
            toast.success("Lead reddedildi — aracıya bildirim gönderildi.");
            setShowRed(false);
            setSebep("");
            onDone?.();
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Red başarısız.");
        } finally {
            setBusy(false);
        }
    }

    if (compact) {
        return (
            <div className="flex gap-1 mt-2">
                <button
                    type="button"
                    disabled={busy}
                    onClick={handleOnayla}
                    className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-semibold bg-emerald-600/80 text-white disabled:opacity-50"
                >
                    {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <CheckCircle2 className="h-3 w-3" />}
                    Onayla
                </button>
                <button
                    type="button"
                    disabled={busy}
                    onClick={() => setShowRed((v) => !v)}
                    className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-semibold border border-rose-500/40 text-rose-300 disabled:opacity-50"
                >
                    <XCircle className="h-3 w-3" /> Red
                </button>
                {showRed && (
                    <input
                        value={sebep}
                        onChange={(e) => setSebep(e.target.value)}
                        placeholder="Red sebebi"
                        className="ml-1 flex-1 min-w-0 h-6 px-2 rounded bg-black/30 border border-white/10 text-[10px]"
                    />
                )}
                {showRed && sebep.trim() && (
                    <button
                        type="button"
                        onClick={handleReddet}
                        disabled={busy}
                        className="text-[10px] text-rose-400 underline"
                    >
                        Gönder
                    </button>
                )}
            </div>
        );
    }

    return (
        <div className="rounded-lg border border-white/10 bg-black/20 p-3 space-y-2">
            <div className="flex flex-wrap gap-2 items-center">
                <label className="flex items-center gap-1.5 text-[10px] text-slate-400">
                    <input type="checkbox" checked={dosyaOlustur} onChange={(e) => setDosyaOlustur(e.target.checked)} />
                    Dosya oluştur
                </label>
                <input
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="Hakediş ₺ (opsiyonel)"
                    value={hakedisTutar}
                    onChange={(e) => setHakedisTutar(e.target.value)}
                    className="h-7 px-2 rounded bg-[#0B0F19] border border-white/10 text-xs w-32"
                />
            </div>
            <div className="flex flex-wrap gap-2">
                <button
                    type="button"
                    disabled={busy}
                    onClick={handleOnayla}
                    className="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg bg-emerald-600 text-white text-xs font-semibold disabled:opacity-50"
                >
                    {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <CheckCircle2 className="h-3.5 w-3.5" />}
                    Onayla + müvekkil
                </button>
                <button
                    type="button"
                    disabled={busy}
                    onClick={() => setShowRed((v) => !v)}
                    className="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg border border-rose-500/40 text-rose-300 text-xs disabled:opacity-50"
                >
                    <XCircle className="h-3.5 w-3.5" /> Reddet
                </button>
            </div>
            {showRed && (
                <div className="flex gap-2">
                    <input
                        value={sebep}
                        onChange={(e) => setSebep(e.target.value)}
                        placeholder="Red sebebi (aracıya gider)"
                        className="flex-1 h-8 px-3 rounded-lg bg-[#0B0F19] border border-white/10 text-xs"
                    />
                    <button
                        type="button"
                        onClick={handleReddet}
                        disabled={busy || !sebep.trim()}
                        className="h-8 px-3 rounded-lg bg-rose-600 text-white text-xs font-semibold disabled:opacity-50"
                    >
                        Red gönder
                    </button>
                </div>
            )}
        </div>
    );
}
